export default __webpack_public_path__ + "static/medgas_panel_w.3ea040d9bda6202996df924ced41d9d7.png";